import * as React from 'react';

import ContentCardStatsHeader from '../header/ContentCardStatsHeader';
import ContentCardStatsRow from '../row/ContentCardStatsRow';

import { getCountMetric, getRateMetric } from 'utils/metrics';
import { renderPrice } from 'utils/helper/price';

import type {
  ContentCardItem
} from 'components/cards/content-card/types';

type Props = {
  item: ContentCardItem
};

const ContentCardStatsYoutubeVideo = ({
  item
}: Props): JSX.Element => (
  <div className="content-card-stats__section">
    <ContentCardStatsHeader
      type="video"
      date={item.date}
    />
    <ContentCardStatsRow
      type="total-reactions"
      contentType="video"
      metricType="followers"
      value={String(getCountMetric(item.metrics?.reactions, true))}
    />
    <ContentCardStatsRow
      type="engagement-rate"
      contentType="video"
      metricType="views"
      value={String(getRateMetric(item.metrics?.engagementRate || 0))}
    />
    <ContentCardStatsRow
      type="media-value"
      contentType="video"
      metricType="followers"
      value={renderPrice(item.metrics?.mediaValue || 0)}
    />
  </div>
);

export default ContentCardStatsYoutubeVideo;
